module.exports = __webpack_public_path__ + "media/images/camp_geer_image_1-8ff9334fe5d54ebac8953a6400a234b3.jpg";